import history from './history';

//Login
const LOGIN = '/login';

//Subscriber
const SUBSCRIBER = '/subscriber';
const ADMIN = '/admin';
const ADD_SUBSCRIBER = '/subscriber/add-subscriber';
const SUBSCRIBER_DETAILS = '/subscriber/details';
const ALL_SUBSCRIBER_DETAILS = '/admin/details';
const PAGE_NOT_FOUND = '/*';
const REPORTING = '/reporting';
const OFFERS = '/offers';
const OFFER_DETAILS = '/offer';
const PROGRAM = '/subscriber/program';
const UNAUTHORISED = '/unauthorised';
const PAD = '/pad';
const LICENCEE_MARK = '/licencee-mark';
const LICENCEE_MARK_WITH_VENDOR = '/:vendorId/licencee-mark';

// Content Library
const CONTENT_LIBRARY = '/content-library';

//Password
const RESET_PASSWORD = '/reset-password';

//Vendor Management
const VENDOR_MANAGEMENT = '/vendors';
const VENDOR = '/vendor';

//LAWREADY
const LAWREADY = '/lawReady';

// Content Builder
const CONTENT_BUILDER = '/content-builder';

// User Details
const USER_DETAILS = '/user';

const redirect = (path, state) => {
    history.push(path, state);
};

const pop = () => {
    history.back();
};

export default {
    redirect: redirect,
    pop: pop,
    history: history,
    LOGIN: LOGIN,
    SUBSCRIBER: SUBSCRIBER,
    ADMIN: ADMIN,
    SUBSCRIBER_DETAILS: SUBSCRIBER_DETAILS,
    ALL_SUBSCRIBER_DETAILS: ALL_SUBSCRIBER_DETAILS,
    CONTENT_LIBRARY: CONTENT_LIBRARY,
    ADD_SUBSCRIBER: ADD_SUBSCRIBER,
    RESET_PASSWORD: RESET_PASSWORD,
    PAGE_NOT_FOUND: PAGE_NOT_FOUND,
    REPORTING: REPORTING,
    OFFERS: OFFERS,
    VENDOR_MANAGEMENT: VENDOR_MANAGEMENT,
    VENDOR_DETAILS: VENDOR,
    OFFER_DETAILS: OFFER_DETAILS,
    LAWREADY: LAWREADY,
    CONTENT_BUILDER: CONTENT_BUILDER,
    USER_DETAILS: USER_DETAILS,
    PROGRAM: PROGRAM,
    UNAUTHORISED: UNAUTHORISED,
    PAD: PAD,
    LICENCEE_MARK: LICENCEE_MARK,
    LICENCEE_MARK_WITH_VENDOR: LICENCEE_MARK_WITH_VENDOR
};
